import { render, staticRenderFns } from "./ClientNutritionProgramsTable.vue?vue&type=template&id=27c0b2e2&"
import script from "./ClientNutritionProgramsTable.vue?vue&type=script&lang=js&"
export * from "./ClientNutritionProgramsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports